module.exports = __webpack_public_path__ + "img/lzd.f4283578.jpg";